export default "__VITE_ASSET__TP0CpLvh__"